<div class="marquee">
  <div class="marquee__container">
    <div #group1 class="marquee__group">
      <div *ngFor="let logo of logos; trackBy: trackByLogoIndex" class="marquee__elem">
        <picture>
          <source [srcset]="logo.src | imaginarySrc: 4:logo.width" />
          <img
            class="training-view__background__image"
            [src]="logo.src | imaginarySrc: 1:logo.width"
            loading="lazy"
            [attr.alt]="logo.alt"
          />
        </picture>
      </div>
    </div>

    <div #group2 class="marquee__group">
      <div *ngFor="let logo of logos; trackBy: trackByLogoIndex" class="marquee__elem">
        <picture>
          <source [srcset]="logo.src | imaginarySrc: 4:logo.width" />
          <img
            class="training-view__background__image"
            [src]="logo.src | imaginarySrc: 1:logo.width"
            loading="lazy"
            [attr.alt]="logo.alt"
          />
        </picture>
      </div>
    </div>
  </div>
</div>
